/* Reject storefront HTML/challenge responses before treating a cart mutation as successful. */
(() => {
  async function readCartResponse(response) {
    const failure = () => Object.assign(new Error('Cart request failed'), {
      status: response.status,
      url: response.url,
      contentType: response.headers.get('content-type') || ''
    });
    const contentType = response.headers.get('content-type') || '';
    // Shopify Ajax endpoints also return JSON with a JavaScript media type.
    const mediaType = contentType.split(';', 1)[0].trim();
    if (!/^(?:application\/(?:[\w.-]+\+)?json|(?:text|application)\/javascript)$/i.test(mediaType)) throw failure();
    let data;
    try { data = await response.json(); } catch (_) { throw failure(); }
    if (!data || typeof data !== 'object' || Array.isArray(data)) throw failure();
    if (!response.ok && !data.status) throw failure();
    return data;
  }
  if (typeof window !== 'undefined') window.readCartResponse = readCartResponse;
  if (typeof module !== 'undefined') module.exports = { readCartResponse };
})();
